<div class="list-toolbar">
  <mat-form-field appearance="outline" class="filter" subscriptSizing="dynamic">
    <mat-label>Status</mat-label>
    <mat-select [(ngModel)]="status" (selectionChange)="onFilterChange()">
      <mat-option value="">All</mat-option>
      <mat-option value="Pending">Pending</mat-option>
      <mat-option value="Fulfilled">Fulfilled</mat-option>
      <mat-option value="Rejected">Rejected</mat-option>
      <mat-option value="Cancelled">Cancelled</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="filter" subscriptSizing="dynamic">
    <mat-label>Pay via</mat-label>
    <mat-select [(ngModel)]="payVia" (selectionChange)="onFilterChange()">
      <mat-option value="">Any</mat-option>
      @for (name of payViaOptions; track name) {
      <mat-option [value]="name">{{ name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="f-datetime" subscriptSizing="dynamic">
    <mat-label>Requested from</mat-label>
    <input matInput type="datetime-local" [(ngModel)]="createdFrom" (change)="onFilterChange()"
      [attr.max]="createdTo || null">
  </mat-form-field>

  <mat-form-field appearance="outline" class="f-datetime" subscriptSizing="dynamic">
    <mat-label>Requested to</mat-label>
    <input matInput type="datetime-local" [(ngModel)]="createdTo" (change)="onFilterChange()"
      [attr.min]="createdFrom || null">
  </mat-form-field>

  <mat-form-field appearance="outline" class="f-amount" subscriptSizing="dynamic">
    <mat-label>Min amount</mat-label>
    <input matInput type="number" min="0" step="1" [(ngModel)]="minAmount" (change)="onFilterChange()">
    <span matTextSuffix>Toman</span>
  </mat-form-field>

  <mat-form-field appearance="outline" class="f-amount" subscriptSizing="dynamic">
    <mat-label>Max amount</mat-label>
    <input matInput type="number" min="0" step="1" [(ngModel)]="maxAmount" (change)="onFilterChange()">
    <span matTextSuffix>Toman</span>
  </mat-form-field>

  @if (hasExtraFilters) {
  <button mat-button type="button" (click)="clearExtraFilters()">
    <mat-icon>filter_alt_off</mat-icon> Clear
  </button>
  }
  <p class="hint">
    <mat-icon>info</mat-icon>
    Open a request to see what it covers and pay it in one step.
  </p>
</div>

<div class="table-card">
@if (loading) {
<div class="table-state"><mat-spinner diameter="28"></mat-spinner></div>
} @else if (error) {
<div class="table-state error">{{ error }}</div>
} @else if (requests.length === 0) {
<div class="table-state">No payment requests match this filter.</div>
} @else {

@if (isMobile$ | async) {
<div class="cards">
  @for (r of requests; track r.id) {
  <div class="card clickable" (click)="open(r)">
    <div class="card-head">
      <div class="card-title">
        {{ r.supplier_name }}
        <p class="card-meta">{{ r.created_at | date:'medium' }}</p>
      </div>
      <span class="chip" [ngClass]="statusClass(r.status)">{{ r.status }}</span>
    </div>
    <p class="amount">{{ r.amount | number }} <small>Toman</small></p>
    @if (r.payout_method_name) {
    <p class="card-meta">Pay via {{ r.payout_method_name }}@if (r.payout_amount) { · {{ r.payout_amount }} {{ r.payout_currency }} }</p>
    }
    @if (r.crypto_payout_status) { <p class="card-meta">On chain: {{ cryptoLabel(r.crypto_payout_status) }}</p> }
    @if (r.supplier_note) { <p class="card-meta note">Supplier: {{ r.supplier_note }}</p> }
    @if (r.admin_note) { <p class="card-meta note">Admin: {{ r.admin_note }}</p> }
  </div>
  }
</div>
} @else {
<div class="table-scroll">
  <table mat-table [dataSource]="requests">
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>Requested</th>
      <td mat-cell *matCellDef="let r">{{ r.created_at | date:'short' }}</td>
    </ng-container>
    <ng-container matColumnDef="supplier">
      <th mat-header-cell *matHeaderCellDef>Supplier</th>
      <td mat-cell *matCellDef="let r">{{ r.supplier_name }}</td>
    </ng-container>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef>Requested</th>
      <td mat-cell *matCellDef="let r" class="num strong">{{ r.amount | number }}</td>
    </ng-container>
    <ng-container matColumnDef="via">
      <th mat-header-cell *matHeaderCellDef>Pay via</th>
      <td mat-cell *matCellDef="let r">
        {{ r.payout_method_name || '—' }}
        @if (r.payout_amount) { <div class="sub num" dir="ltr">{{ r.payout_amount }} {{ r.payout_currency }}</div> }
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let r">
        <span class="chip" [ngClass]="statusClass(r.status)">{{ r.status }}</span>
        @if (r.closed_at) { <div class="sub">{{ r.closed_at | date:'short' }}</div> }
        @if (r.crypto_payout_status) { <div class="sub">On chain: {{ cryptoLabel(r.crypto_payout_status) }}</div> }
      </td>
    </ng-container>
    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>Notes</th>
      <td mat-cell *matCellDef="let r" class="notes">
        @if (r.supplier_note) { <div><span class="muted">Supplier:</span> {{ r.supplier_note }}</div> }
        @if (r.admin_note) { <div><span class="muted">Admin:</span> {{ r.admin_note }}</div> }
      </td>
    </ng-container>
    <ng-container matColumnDef="open">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let r"><mat-icon>chevron_right</mat-icon></td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns;" class="clickable" (click)="open(row)"></tr>
  </table>
</div>
}

<mat-paginator
  [length]="total"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
  (page)="onPage($event)">
</mat-paginator>
}
</div>
